<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import GlobalSearchSection from '@/components/global-search-section.vue';
import SliderItem from '@/components/Slider/SliderItem.vue';
import SliderItemSport from '@/components/Slider/SliderItemSport.vue';
import SliderLiveTv from '@/components/Slider/SliderLiveTv.vue';
import { SEARCH_ROUTE_QUERY, SEARCH_TABS } from '@/views/Search/constants';

const props = defineProps({
  order: { type: Object, required: true },
});

const store = useStore();
const { t } = useI18n();

const searchMovies = computed(() => store.state.movies.searchMovies);
const searchTvShows = computed(() => store.state.tvShows.searchTvShows);
const searchSports = computed(() => store.state.sportsVod.searchSports);
const searchLiveTv = computed(() => store.state.liveTv.searchLiveTv);
const searchText = computed(() => store.state.movies.searchText);
const brandImage = computed(() => `/img/${store.state.config?.brandName}-logo.png`);

const shouldDisplay = computed(() => searchMovies.value || searchTvShows.value || searchSports.value || searchLiveTv.value);

const sections = computed(() => [
  { name: 'movies', tab: SEARCH_TABS.movies, titleKey: 'search.movies', component: SliderItem, itemProps: { brandImage: brandImage.value }, items: searchMovies.value },
  { name: 'tvshow', tab: SEARCH_TABS.tvShows, titleKey: 'search.tvShows', component: SliderItem, itemProps: { brandImage: brandImage.value }, items: searchTvShows.value },
  { name: 'sports', tab: SEARCH_TABS.sportsVod, titleKey: 'search.sportsVOD', component: SliderItemSport, itemProps: {}, items: searchSports.value },
  { name: 'livetv', tab: SEARCH_TABS.liveTv, titleKey: 'search.channels', component: SliderLiveTv, itemProps: {}, items: searchLiveTv.value },
]);

const visibleSections = computed(() => sections.value.filter(({ items }) => items?.length).sort((a, b) => props.order[a.name] - props.order[b.name]));

const getViewAllRoute = (tab) => ({
  name: 'Search',
  query: { [SEARCH_ROUTE_QUERY.query]: searchText.value, [SEARCH_ROUTE_QUERY.tab]: tab },
});

const closeSearch = () => {
  store.commit('setSearchMovies', { text: undefined, movies: undefined });
};
</script>

<template>
  <div v-if="shouldDisplay" class="global-search">
    <div class="global-search__head">
      <button type="button" class="global-search__back" :aria-label="t('search.back')" @click="closeSearch">←</button>
      <div>
        <h2 class="global-search__title">{{ t('search.resultsFor', { query: searchText }) }}</h2>
        <p class="global-search__meta">{{ t('search.allContentTypes') }}</p>
      </div>
    </div>

    <GlobalSearchSection
      v-for="section in visibleSections"
      :key="section.name"
      :title="t(section.titleKey)"
      :items="section.items"
      :component="section.component"
      :item-props="section.itemProps"
      :view-all-route="getViewAllRoute(section.tab)"
    />
  </div>
</template>

<style lang="scss" scoped>
.global-search {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px 4% 40px;

  &__head {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  &__back {
    display: grid;
    flex-shrink: 0;
    place-items: center;
    width: 36px;
    height: 36px;
    border: 1px solid $black80;
    border-radius: 4px;
    background: $black30;
    color: $white;
    font-size: 1.1rem;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      border-color: $white;
    }
  }

  &__title {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 700;
    color: $white;

    @include mobile-sm-max {
      font-size: 1.35rem;
    }
  }

  &__meta {
    margin: 4px 0 0;
    font-size: 0.8rem;
    color: $light-gray;
  }
}
</style>

<style lang="scss">
.slider-container-newmovies {
  display: flex;
  column-gap: 50px;
  flex-wrap: wrap;
  row-gap: 60px;
  justify-content: center;
  margin-left: 100px;
  margin-right: 100px;

  .lolomoRow {
    max-width: 300px;

    .wrapper__back:hover {
      display: none;
    }

    .wrapper__front:hover {
      opacity: 1;
    }

    li {
      min-width: 120%;
    }
  }

  .category-slider-hider {
    width: 95%;
    height: 100%;
    position: relative;
    top: -91%;
    cursor: pointer;
  }
}

.slider-container {
  margin-top: 5rem;
}

.loader {
  &-billboard {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
  }

  &-categories {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
  }
}

.row-header-title {
  cursor: pointer;
}
</style>
